module.exports = __webpack_public_path__ + "static/cioreview-award-06aee767d3a7cf1cb225a699b475825e.jpg";